<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Salary Details
    </div>
    <div class="card-body">
        <div class="card-body p-1" style="overflow: auto; height: 450px;">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th scope="col" style="width: 5px;">Payslip</th>
                        <th scope="col" style="width: 5px;">Attendance</th>
                        <th scope="col">Employee</th>
                        <th scope="col">Month Year</th>
                        <th scope="col">Branch Name</th>
                        <th scope="col">Client Name</th>
                        <th scope="col">Site Name</th>
                        <th scope="col">Month Days</th>
                        <th scope="col">Normal Days</th>
                        <th scope="col">Weekly Off</th>
                        <th scope="col">Leave Days</th>
                        <th scope="col">OT Days</th>
                        <th scope="col">OT Hours</th>
                        <th scope="col">Joining Date</th>
                        <th scope="col">Date Of Birth</th>
                        <th scope="col">Total Gross</th>
                        <th scope="col">Total Deduction</th>
                        <th scope="col">Net Payable</th>
                        <th scope="col">PAN No</th>
                        <th scope="col">Bank Name</th>
                        <th scope="col">Bank Branch Name</th>
                        <th scope="col">IFSC Code</th>
                        <th scope="col">Bank Account No</th>
                        <th scope="col">Upload Batch No</th>
                        <th scope="col">Upload Batch Date</th>
                        <th scope="col">PF No</th>
                        <th scope="col">ESIC No</th>
                        <th scope="col">UAN No</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let site of SalarySummary; let i = index">
                        <td style="width: 5px;">
                            <div class="text-center">
                                <i (click)="ViewSalarySlip(site)" class="bi bi-eye cursor-pointer fw-bold"></i>
                            </div>
                        </td>
                        <td style="width: 5px;">
                            <div class="text-center">
                                <i (click)="ViewAttendance(site)" class="bi bi-file-person"></i>
                            </div>
                        </td>
                        <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img *ngIf="site['Photo'] != null && site['Photo'] != ''" mat-card-image
                                        class="userImage" [src]="common.PhotoLink(site['Photo'])" />
                                    <div *ngIf="site['Photo'] == null || site['Photo'] == ''" class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(site['EmpName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9 userdetail">
                                    <span class="text-label">{{site['EmpName']}}</span><br />
                                    <span class="text-label-light">#{{site['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{site['DesignationName']}}</span>
                                </div>
                            </div>
                        </td>
                        <td>{{ site['MonthYear'] }}</td>
                        <td>{{ site['BranchName'] }}</td>
                        <td>{{ site['ClientGroupName'] }}</td>
                        <td>{{ site['SiteName'] }}</td>
                        <td>{{ site['MonthDays'] }}</td>
                        <td>{{ site['NormalDays'] }}</td>
                        <td>{{ site['WeeklyOff'] }}</td>
                        <td>{{ site['LeaveDays'] }}</td>
                        <td>{{site['OTDays']}}</td>
                        <td>{{ site['OTHours'] }}</td>
                        <td>{{ site['JoiningDate'] }}</td>
                        <td>{{ site['DateOfBirth'] }}</td>
                        <td>{{ site['TotalGross'] }}</td>
                        <td>{{ site['TotalDeduction'] }}</td>
                        <td>{{ site['NetPayable'] }}</td>
                        <td>{{ site['PANNo'] }}</td>
                        <td>{{site['BankName']}}</td>
                        <td>{{ site['BankBranchName'] }}</td>
                        <td>{{site['IFSCode']}}</td>
                        <td>{{ site['BankAccountNo'] }}</td>
                        <td>{{ site['UploadBatchNo'] }}</td>
                        <td>{{ site['UploadBatchDate'] }}</td>
                        <td>{{ site['PFNo'] }}</td>
                        <td>{{site['ESICNo']}}</td>
                        <td>{{site['UANNo']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>